import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__VRO8j","info":"styles_info__VdqWD","error":"styles_error__CE-xh","success":"styles_success__nkQMx","warning":"styles_warning__FaW-Y","invert":"styles_invert__-7IPT","arrow":"styles_arrow__qOOsP"};
export const b = b_.with('tooltip');